export default {"src":"/_next/static/media/PayPal.e52e4b39.svg","height":30,"width":26,"blurWidth":0,"blurHeight":0};